import { handleActions } from 'redux-actions';
import * as Actions from '../actions/mentorActions';

const app = handleActions({
  [Actions.setSchoolApplications]: (state, action) => ({
    ...state,
    schoolApplications: action.payload,
  }),
  [Actions.setSchoolAttendanceAttended]: (state, action) => ({
    ...state,
    schoolApplications: state.schoolApplications.map((x) => (x.id === action.payload.id ? { ...x, attendance: { ...x.attendance, attended: action.payload.attended } } : x)),
  }),
}, {
  schoolApplications: [],
});

export default app;
